import { render, staticRenderFns } from "./ClientSelector.vue?vue&type=template&id=f1a4e3f8&scoped=true"
import script from "./ClientSelector.vue?vue&type=script&lang=js"
export * from "./ClientSelector.vue?vue&type=script&lang=js"
import style0 from "./ClientSelector.vue?vue&type=style&index=0&id=f1a4e3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a4e3f8",
  null
  
)

export default component.exports